// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"b1509da6","302":"5c71e056","307":"1409ddbe","650":"db2f5fc0","668":"ac939b11","826":"c0c344f1","835":"f5c34dc2","908":"ddd163af"}[chunkId] + ".chunk.css";
};